import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useState } from "react";

import { MainButton } from "../../../../components/button";
import Panel from "../Panel";
import { Heading, Intro } from "../Typography";
import {
  Field,
  Input,
  Label,
  SubmitButton,
} from "../../../../components/forms";
import useLocation from "../../../../hooks/useLocation";

const MIN_BIRTH_YEAR = new Date().getFullYear() - 120;
const MAX_BIRTH_YEAR = new Date().getFullYear();

const MIN_AGE = 10;

const schema = Yup.object().shape({
  yearOfBirth: Yup.number()
    .typeError("Please enter a year")
    .positive()
    .integer()
    .required("Required")
    .min(MIN_BIRTH_YEAR, `Must be at least ${MIN_BIRTH_YEAR}`)
    .max(MAX_BIRTH_YEAR, "Must not be in the future"),
});

type Values = {
  yearOfBirth: number | "";
};

const AgeScreen = () => {
  const navigate = useNavigate();
  const location = useLocation<{ email: string }>();

  const [isTooYoung, setIsTooYoung] = useState(false);

  const onSubmit = ({ yearOfBirth }: Values) => {
    if (yearOfBirth === "") {
      // should not happen as Yup should cast for us
      throw new Error("missing number value");
    }
    const isTooYoungUpdated = yearOfBirth > new Date().getFullYear() - MIN_AGE;
    setIsTooYoung(isTooYoungUpdated);
    if (!isTooYoungUpdated) {
      navigate("../register", {
        state: { isParent: false, yearOfBirth, email: location.state?.email },
      });
    }
  };

  return (
    <Panel>
      {!isTooYoung ? (
        <>
          <Heading size="small">What year were you born?</Heading>
          <Intro>
            We need to check you’re old enough to complete the registration and
            sign yourself up.
          </Intro>
          <Formik
            initialValues={{ yearOfBirth: "" }}
            onSubmit={onSubmit}
            validationSchema={schema}
          >
            <Form>
              <Field name="yearOfBirth">
                <Label>Year of birth</Label>
                <Input type="text" inputMode="numeric" />
              </Field>
              <SubmitButton>Continue</SubmitButton>
            </Form>
          </Formik>
        </>
      ) : (
        <>
          <Heading size="small">You’re too young, get an adult</Heading>
          <Intro>
            You ned an adult for this bit. Please ask a parent or guardian to
            complete the registration for you.
          </Intro>
          <MainButton variant="secondary" onClick={() => navigate("../")}>
            Try again
          </MainButton>
        </>
      )}
    </Panel>
  );
};

export default AgeScreen;
